<template>
    <v-container class="py-5">
        <v-breadcrumbs :items="breadcrumbs" large></v-breadcrumbs>
        <v-row>
            <!-- card main -->
            <v-col cols="12" md="12">
                <v-card>
                    <v-card-title class="blue-grey darken-4 white--text">
                        <div>{{ $t("Lista de Pantallas") }}</div>
                    </v-card-title>

                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left text-uppercase">
                                            {{ $t("Titulo de pantalla") }}
                                        </th>
                                        <th class="text-left text-uppercase">
                                            {{ $t("Categorias") }}
                                        </th>
                                        <th class="text-left text-uppercase">
                                            {{ $t("Enlace") }}
                                        </th>
                                        <th class="text-right text-uppercase">
                                            {{ $t("Acciones") }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, index) in screenList"
                                        :key="index"
                                    >
                                        <td>{{ item.category_name }}</td>
                                        <td>
                                            <span
                                                v-if="
                                                    item.categories &&
                                                    item.categories.length
                                                "
                                            >
                                                {{
                                                    getCategoryNames(
                                                        item.categories
                                                    ).join(", ")
                                                }}
                                            </span>
                                            <span v-else>-</span>
                                        </td>
                                        <td>
                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="
                                                            copyLink(item.id)
                                                        "
                                                    >
                                                        <v-icon color="grey"
                                                            >mdi-content-copy</v-icon
                                                        >
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('Copiar enlace') }}</span>
                                            </v-tooltip>
                                        </td>

                                        <td class="text-right">
                                            <div class="d-flex justify-end">
                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <v-btn
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            icon
                                                            @click="
                                                                editScreen(
                                                                    item.id
                                                                )
                                                            "
                                                        >
                                                            <v-icon
                                                                color="grey"
                                                            >
                                                                mdi-pencil
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('Editar') }}</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
                <div class="text-right py-2" v-html="pageTable"></div>
                <v-pagination
                    v-model="page"
                    :length="totalPage"
                    :total-visible="5"
                    color="primary"
                    @input="changePage"
                    class="my-5"
                ></v-pagination>
            </v-col>
            <!-- end card main -->
        </v-row>

        <!-- dialog edit -->
        <v-dialog v-model="dialogEdit" max-width="400px" scrollable>
            <v-form @submit.prevent="edit" ref="refEdit" lazy-validation>
                <v-card :loading="loading">
                    <v-card-title> {{ $t("Editar pantalla") }} </v-card-title>
                    <v-card-text class="pt-3">
                        <!-- name category -->
                        <v-text-field
                            :label="$t('Nombre de la categoria')"
                            outlined
                            dense
                            v-model="data2.category_name"
                            :rules="[rules.required]"
                            :error="errors['name'] ? true : false"
                            :error-messages="
                                errors['name'] ? errors['name'][0] : ''
                            "
                        ></v-text-field>
                        <!-- end name category -->
                        <!-- categories -->

                        <v-select
                            :label="$t('Categorías')"
                            multiple
                            outlined
                            dense
                            v-model="data2.categories"
                            :items="categories"
                            item-text="name"
                            item-value="id"
                            :rules="[rules.required]"
                            :error="!!errors.categories"
                            :error-messages="
                                errors.categories ? errors.categories[0] : ''
                            "
                        />
                        <!-- end categories -->
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error"
                            text
                            @click="dialogEdit = false"
                            :disabled="loading"
                        >
                            {{ $t("Cancelar") }}
                        </v-btn>
                        <v-btn color="primary" :loading="loading" type="submit">
                            {{ $t("Actualizar") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- end dialog edit -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </v-container>
</template>
<script>
export default {
    computed: {
        currentUrl() {
            return window.location.origin;
        },
    },
    data() {
        return {
            overlay: false,
            loading: false,
            show1: true,
            breadcrumbs: [
                {
                    text: "Pantallas",
                    disabled: true,
                    href: "",
                },
            ],
            itemsRole: [],
            //categorias
            categories: [],
            // user list
            screenList: [],
            pageTable: "",
            page: 1,
            totalPage: null,
            txtSearch: "",
            // edit
            dialogEdit: false,
            data2: {
                id: "",
                category_name: "",
                categories: [],
            },

            // validation
            rules: {
                required: (v) => !!v || "El campo es obligatorio",
                min: (v) => v.length >= 8 || "Mínimo 8 caracteres",
                phone: (v) =>
                    (v.length >= 12 && v.length <= 12) ||
                    "Debe contener 12 dígitos",
                email: (v) => /.+@.+\..+/.test(v) || "Email inválido",
            },
            errors: {},
        };
    },
    props: ["points", "preventist", "typeStore", "slug"],

    mounted() {
        this.getScreenList();
        this.loadCategories();
    },
    methods: {
        copyLink(id) {
            const url = `${this.currentUrl}/${this.slug}/pantalla/${id}`;
            const textArea = document.createElement("textarea");
            textArea.value = url;
            document.body.appendChild(textArea);
            textArea.select();

            try {
                document.execCommand("copy");
                this.$alert("Enlace copiado", "", "success");
            } catch (err) {
                console.error("Error al copiar:", err);
                this.$alert(
                    "No se pudo copiar automáticamente",
                    "",
                    "❌ Error"
                );
            }

            document.body.removeChild(textArea);
        },
        getCategoryNames(ids) {
            return ids
                .map((id) => {
                    const cat = this.categories.find(
                        (c) => c.id === id || String(c.id) === String(id)
                    );
                    return cat ? cat.name : null;
                })
                .filter((name) => name); // elimina nulls
        },
        
        changePage(event) {
            this.page = event;
            this.getUserList();
        },
  
        async getScreenList() {
            this.screenList = [];
            this.overlay = true;
            await axios
                .get(
                    `/admin/screens-list?page=${this.page}&search=${this.txtSearch}`
                )
                .then((response) => {
                    this.screenList = response.data.data;
                    this.totalPage = response.data.last_page;
                    this.pageTable = `Showing <strong>${
                        response.data.from ?? 0
                    } - ${
                        response.data.to ?? 0
                    }</strong> of a total of <strong>${
                        response.data.total
                    }</strong>`;
                    this.overlay = false;
                })
                .catch((error) => {
                    // console.log(error)
                    if (
                        error.response.status == 404 ||
                        error.response.status == 500
                    ) {
                        this.$alert(
                            "Error del servidor, inténtalo de nuevo más tarde."
                        );
                    }
                    this.overlay = false;
                });
        },
        async loadCategories() {
            try {
                const response = await axios.get("/admin/categories-get"); // ajusta a tu ruta real
                this.categories = response.data;
            } catch (error) {
                console.error("Error cargando categorías", error);
            }
        },
        /**
         * Editar
         */
        editScreen(id) {
            const tmpData = this.screenList.find((item) => item.id === id);

            this.data2.id = tmpData.id;
            this.data2.category_name = tmpData.category_name;

            let ids = [];

            if (Array.isArray(tmpData.categories)) {
                ids = tmpData.categories;
            } else if (typeof tmpData.categories === "string") {
                try {
                    ids = JSON.parse(tmpData.categories);
                } catch (e) {
                    ids = [];
                }
            }

            const normalizedIds = ids.map(String);
            this.data2.categories = this.categories.filter((cat) =>
                normalizedIds.includes(String(cat.id))
            );

            this.dialogEdit = true;
        },

        async edit() {
            if (this.$refs.refEdit.validate()) {
                this.errors = {};
                this.loading = true;

                // Extraer solo IDs (ya sean objetos o IDs directos)
                const categoryIds = this.data2.categories.map((c) =>
                    typeof c === "object" ? c.id : c
                );

                await axios
                    .put(`/admin/screens/${this.data2.id}`, {
                        category_name: this.data2.category_name,
                        categories: categoryIds,
                    })
                    .then((response) => {
                        if (response.data === "ok") {
                            this.$alert(
                                "",
                                "Datos actualizados con éxito.",
                                "success",
                                { confirmButtonText: "Continuar" }
                            );
                            this.getScreenList();
                            this.dialogEdit = false;
                            this.$refs.refEdit.resetValidation();
                        }
                    })
                    .catch((error) => {
                        if (error.response?.data?.errors) {
                            this.errors = error.response.data.errors;
                        }
                        if (
                            error.response?.status === 404 ||
                            error.response?.status === 500
                        ) {
                            this.$alert(
                                "Error del servidor, inténtalo de nuevo más tarde."
                            );
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },

        /**
         * roles de la tienda
         */
        
    },
};
</script>
